import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/selectedStar.svg'
import _imports_1 from '@/assets/images/star.svg'


const _withScopeId = n => (_pushScopeId("data-v-1c549ca3"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-label"]
const _hoisted_2 = ["alt"]
const _hoisted_3 = ["alt"]




export default /*#__PURE__*/_defineComponent({
  __name: 'StarsCounter',
  props: {
    stars: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "flex items-center",
    "aria-label": _ctx.$t('starsCounter.rating') + ' ' + __props.stars + ' ' + _ctx.$t('starsCounter.ratingOutOf') + ' 5'
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.stars, (star) => {
      return (_openBlock(), _createElementBlock("img", {
        key: 'selectedStar' + star,
        src: _imports_0,
        alt: _ctx.$t('starsCounter.starIconAlt'),
        class: "pr-1 star"
      }, null, 8, _hoisted_2))
    }), 128)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((5 - __props.stars), (star) => {
      return (_openBlock(), _createElementBlock("img", {
        key: 'selectedStar' + star,
        src: _imports_1,
        alt: _ctx.$t('starsCounter.starIconAlt'),
        class: "pr-1 star"
      }, null, 8, _hoisted_3))
    }), 128))
  ], 8, _hoisted_1))
}
}

})